
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import Toasted from 'vue-toasted';
import Groups from '../../group/Groups';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    Groups,
  },
})
export default class AdvanceRegistrationConfig extends Vue {
}
